import React, { useEffect, useState } from "react";
import { apiLogin } from "../../../services/Auth/login";
import useAuth from "../../../hooks/useAuth";
import { Link, useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import MsgError from "../../../components/MsgError";
import { LoadingButton } from "@mui/lab";
import { RouteAuth } from "../../../routes/RouteAuth";
import { RouteAdmin } from "../../../routes/RouteAdmin";
import MsgSuccess from "../../../components/MsgSuccess";
import jwtDecode from "jwt-decode";
import { RouteUser } from "../../../routes/RouteUser";
import logo from '../../../assets/images/logo-scaled.png'
import { IS_BETA } from "../../../utils/constants";
import { ActionButton } from "../../../components/Admin/Inputs";

const theme = createTheme();

export default function LoginForm() {

    const { login } = useAuth()
    const navigate = useNavigate()
    const params = new URLSearchParams(window.location.search)

    const [state, setState] = useState(initialValues())
    const [msgError, setMsgError] = useState([])
    const [msgSuccess, setMsgSuccess] = useState([])
    const [loading, setLoading] = useState(false)
    const pjson = require("../../../../package.json")

    const handleChange = (event) => {
        state[event.target.name] = event.target.value
        setState({ ...state })
    }

    const handleSubmit = (event) => {
        setLoading(true)
        event.preventDefault()

        setMsgError([])
        let error = validationSchema(state)

        if (error.length !== 0) {
            setMsgError(error)
            setLoading(false)
            return
        }

        apiLogin(state).then(resp => {
            startLogin(resp.data?.token)
        }).catch(err => {
            if (err.response?.data?.msg) {
                setMsgError(err.response?.data?.msg)
            } else {
                setMsgError(["Parece que algo ha ido mal, inténtalo más tarde o contacta con el administrador."])
            }
            setLoading(false)
        })
    }

    const startLogin = async (token) => {
        if (jwtDecode(token).roles[0] === "ROLE_ADMIN") {
            await login({
                primaryUser: token,
                secondaryUser: token,
                initial: true
            })
            navigate(RouteAdmin.TRABAJOS_MANAGEMENT.path)
            setLoading(false)

        }
        else if (jwtDecode(token).roles[0] === "ROLE_CLIENT") {
            await login({
                primaryUser: token,
                initial: true
            })
            navigate(RouteUser.MY_ACCOUNT_CLIENT.path)
            setLoading(false)
        }
        else if (jwtDecode(token).roles[0] === "ROLE_WORKER") {
            await login({
                primaryUser: token,
                initial: true
            })
            navigate(RouteUser.WORKER_CALENDAR.path)
            setLoading(false)
        }
        else if (jwtDecode(token).roles[0] === "ROLE_MANAGER") {
            await login({
                primaryUser: token,
                initial: true
            })
            navigate(RouteAdmin.ORGANIZATIONS_MANAGEMENT.path)
            setLoading(false)
        }
        else {
            await login({
                primaryUser: token,
                initial: true
            })
            navigate(RouteUser.ROOT.path)
            setLoading(false)
        }
    }

    useEffect(() => {
        if (params.get("msg-error")) {
            setMsgError([params.get("msg-error")])
        } else if (params.get("msg")) {
            setMsgSuccess([params.get("msg")])
        }
    }, [])

    return (
        <ThemeProvider theme={theme}>
            <style>{`
                .login-container {
                    margin: auto;
                    padding: 24px;
                    border-radius: 10px;
                    width: 450px;
                    box-shadow: 0 1px 4px rgba(0,0,0,0.08);
                    background-color: white;
                    z-index: 1;
                    position: relative;
                    max-width: 100vw;
                }
                .login-section {
                    background-color: #f4f4f4;
                    min-height: 100vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                @media (max-width: 600px) {
                    .login-container {
                        width: 100% !important;
                        min-width: unset !important;
                        max-width: 100vw !important;
                        border-radius: 0 !important;
                        padding: 16px !important;
                        box-shadow: none !important;
                        background-color: white !important;
                    }
                    .login-logo-row {
                        margin-bottom: 16px !important;
                    }
                    .login-section {
                        background-color: #fff;
                    }
                }
            `}</style>
            <section className="login-section">
                <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%' }}>
                    <div className="login-container">
                        <div className="login-logo-row" style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: 16, alignItems: 'center', flexDirection: 'column' }}>
                            <a href="#inicio" className="logo" style={{ display: 'flex', alignItems: 'center', marginBottom: 8 }}>
                                <div className="logo-icon"></div>
                                <span className="logo-text">Gmatik</span>
                            </a>
                            {IS_BETA && (
                                <span style={{
                                    display: 'inline-block',
                                    background: '#ff1744',
                                    color: 'white',
                                    borderRadius: '12px',
                                    padding: '2px 10px',
                                    fontSize: '0.75rem',
                                    fontWeight: 700,
                                    marginLeft: 0,
                                    letterSpacing: 1,
                                    textTransform: 'uppercase',
                                    boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
                                    marginTop: 0,
                                    height: 22,
                                }}>
                                    BETA
                                </span>
                            )}
                        </div>

                        <h5 style={{ textAlign: 'center' }}>Iniciar sesión</h5>

                        <Box component="form">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12}>
                                    <MsgError msg={msgError} />
                                    <MsgSuccess msg={msgSuccess} />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <p style={{ marginBottom: 4 }}>Correo electrónico</p>
                                    <TextField
                                        required
                                        fullWidth
                                        size="small"
                                        id="username"
                                        name="username"
                                        autoComplete="email"
                                        onChange={handleChange}
                                        autoFocus
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <p style={{ marginBottom: 4 }}>Contraseña</p>
                                    <TextField
                                        required
                                        fullWidth
                                        size="small"
                                        name="password"
                                        type="password"
                                        id="password"
                                        autoComplete="current-password"
                                        onChange={handleChange}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>

                                <Grid item md={12}>
                                    <span style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                        alignItems: 'center',
                                        width: '100%' // <-- Añadido para forzar alineación derecha en móvil
                                    }}>
                                        <Link to={RouteAuth.RECOVER_PASSWORD.path} style={{
                                            textDecoration: 'none',
                                            fontFamily: 'AdminFontBold',
                                            fontSize: '14px',
                                            color: '#a1a1a1ff',
                                            marginTop: "-10px",
                                            fontWeight: '100',
                                        }}>
                                            Has olvidado tu contraseña?
                                        </Link>
                                    </span>
                                </Grid>

                                <Grid item xs={12}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            width: '100%',
                                            gap: '10px'
                                        }}
                                    >
                                        {/* <ActionButton
                                            type="2"
                                            onClick={() => navigate(RouteAuth.SIGNUP.path)}
                                        >
                                            Crear cuenta
                                        </ActionButton> */}

                                        <ActionButton
                                            type="1"
                                            loading={loading}
                                            onClick={handleSubmit}
                                        >
                                            Iniciar sesión
                                        </ActionButton>
                                    </div>
                                </Grid>

                            </Grid>
                        </Box>
                    </div>
                    <div style={{ color: "gray", position: 'absolute', bottom: 20, right: 20, fontSize: 15 }}>v.{pjson.version}</div>
                </div>
            </section>
        </ThemeProvider>
    )
}

function initialValues() {
    return {
        username: "", password: ""
    }
}

function validationSchema(schema) {
    let error = []

    if (!schema.username) {
        error.push("El correo electrónico es obligatorio")
    }
    if (!schema.password) {
        error.push("La contraseña es obligatoria")
    }

    return error
}
